import React, { useState, useEffect } from 'react';
import Menu from '../../Header/Menu';
import {
    CssBaseline,
    makeStyles,
    Grid,
    Card,
    CardActionArea,
    CardHeader,
    Avatar,
    Typography,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(2),
    },
    card: {
        width: '100%',
    },
    avatar: {
        backgroundColor: theme.palette.primary.main,
        width: 45,
    },
    alert: {
        marginTop: theme.spacing(2),
    },
}));

export default function PortalSettings() {
    const classes = useStyles();

    const [list, setList] = useState([]);
    const [area, setArea] = useState([]);
    const [currentPortal, setCurrentPortal] = useState(null);
    const [editFrom, setEditFrom] = useState(0);
    const [editTo, setEditTo] = useState(0);
    const [editError, setEditError] = useState('');
    const [isEditMode, setIsEditMode] = useState(false);

    const handleLoad = () => {
        fetch(process.env.REACT_APP_API_URL + '/parking/portal', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => res.json())
            .then(res => setList(res.portal));
    };

    const loadArea = () => {
        fetch(process.env.REACT_APP_API_URL + '/parking/area', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => res.json())
            .then(res => setArea(res.area));
    };

    useEffect(() => {
        handleLoad();
    }, []);

    const handleSubmit = (action) => {
        let reqMethod;
        let reqBody;
        switch (action) {
            case 'delete':
                reqMethod = 'DELETE';
                reqBody = JSON.stringify({ "id": currentPortal.id });
                break;
            case 'create':
                reqMethod = 'POST';
                reqBody = JSON.stringify({ "from_area": editFrom, "to_area": editTo });
                break;
            case 'update':
                reqMethod = 'PUT';
                reqBody = JSON.stringify({ "id": currentPortal.id, "from_area": editFrom, "to_area": editTo });
                break;
        }
        fetch(process.env.REACT_APP_API_URL + '/parking/portal', {
            method: reqMethod,
            credentials: 'include',
            body: reqBody,
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => {
                switch (res.status) {
                    case 403:
                        setEditError("Запрещено!");
                        setTimeout(() => setEditError(""), 2000);
                        break;
                    case 409:
                        res.json().then(data => {
                            switch (data.code) {
                                case 1:
                                    setEditError("Направление не может указывать само на себя!");
                                    break;
                                case 2:
                                    setEditError("Такое уже есть!");
                                    break;
                            }
                            setTimeout(() => setEditError(""), 2000);
                        });
                        break;
                    default:
                        setCurrentPortal(null);
                        handleLoad();
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    const openDialog = (portal = null) => {
        if (portal) {
            setIsEditMode(true);
            setCurrentPortal(portal);
            setEditFrom(portal.from_area);
            setEditTo(portal.to_area);
        } else {
            setIsEditMode(false);
            setCurrentPortal({});
            setEditFrom(0);
            setEditTo(0);
        }
        loadArea();
    };

    const closeDialog = () => {
        setCurrentPortal(null);
        setEditError('');
    };

    return (
        <React.Fragment>
            <Menu title='Порталы' reloadData={handleLoad} />
            <CssBaseline />
            <div className={classes.root}>
                <Button variant="contained" color="primary" onClick={() => openDialog()}>
                    Новый портал
                </Button>

                <Grid container spacing={1} style={{ marginTop: 16 }}>
                    {list.map((data, i) => (
                        <Grid container item xs={12} sm={6} md={4} lg={4} xl={2} key={i}>
                            <Card className={classes.card}>
                                <CardActionArea onClick={() => openDialog(data)}>
                                    <CardHeader
                                        avatar={
                                            <Avatar variant="rounded" className={classes.avatar}>
                                                <CheckCircleOutlineIcon />
                                            </Avatar>
                                        }
                                        subheader={
                                            <Typography variant="h5" component="h2">
                                                {(data.from_areaT ? data.from_areaT : "Улица")} => {(data.to_areaT ? data.to_areaT : "Улица")}
                                            </Typography>
                                        }
                                    />
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </div>

            <Dialog open={currentPortal !== null} onClose={closeDialog} maxWidth="sm" fullWidth>
                <DialogTitle>{!isEditMode ? 'Новый портал' : 'Редактировать портал'}</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth margin="dense">
                        <InputLabel>Из</InputLabel>
                        <Select
                            value={editFrom}
                            onChange={(e) => setEditFrom(e.target.value)}
                        >
                            <MenuItem value={0}>Улица</MenuItem>
                            {area.map((data, j) => (
                                <MenuItem key={j} value={data.id}>
                                    {data.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth margin="dense">
                        <InputLabel>В</InputLabel>
                        <Select
                            value={editTo}
                            onChange={(e) => setEditTo(e.target.value)}
                        >
                            <MenuItem value={0}>Улица</MenuItem>
                            {area.map((data, j) => (
                                <MenuItem key={j} value={data.id}>
                                    {data.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {editError && (
                        <Alert severity="error" className={classes.alert}>
                            {editError}
                        </Alert>
                    )}
                </DialogContent>
                <DialogActions>
                    {isEditMode && (
                        <Button onClick={() => handleSubmit('delete')} color="secondary">
                            Удалить
                        </Button>
                    )}
                    <Button onClick={closeDialog} color="primary">
                        Отмена
                    </Button>
                    <Button onClick={() => handleSubmit(isEditMode ? 'update' : 'create')} color="primary">
                        {isEditMode ? 'Сохранить' : 'Добавить'}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
